import { createSlice } from "@reduxjs/toolkit";

type UserInitialState = {
  editUserId: string | null;
  editUserFullname: string;
};

const initialState: UserInitialState = {
  editUserId: null,
  editUserFullname: "",
};

const userSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setEditUserData(state, { payload }) {
      state.editUserId = payload.id;
      state.editUserFullname = payload.name;
    },
  },
});
export const userActions = userSlice.actions;
export default userSlice;
